const getCookie = (name) => {
  let value = "; " + document.cookie;
  let parts = value.split("; " + name + "=");
  if (parts.length == 2) return parts.pop().split(";").shift();
};

const setCookie = (name, value, days) => {
  let expires = "";
  if (days) {
    let date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
};

class Localization {
  constructor() {
    this.country = document.querySelector("html").getAttribute("localization");
    this.delay = document
      .querySelector("#shopify-section-location-popup .cc-popup")
      .getAttribute("data-delay-seconds");
    this.mode = document
      .querySelector("#shopify-section-location-popup .cc-popup")
      .getAttribute("data-mode");
  }

  getCountryCode() {
    return new Promise((resolve, reject) => {
      let country_code = getCookie("country_code");
      if (typeof country_code !== "undefined" && this.mode !== "testing") {
        resolve(country_code.toLowerCase());
      } else {
        $.ajax({
          url: "/browsing_context_suggestions.json",
          type: "GET",
          dataType: "json",
          success: function (data) {
            if (typeof data.detected_values?.country?.handle !== "undefined") {
              setCookie("country_code", data.detected_values.country.handle, 30);
              resolve(data.detected_values.country.handle.toLowerCase());
            }
          },
          error: function (error) {
            $.ajax({
              url: "https://ipapi.co/json/",
              type: "GET",
              dataType: "json",
              success: function (data) {
                if (typeof data.country_code !== "undefined") {
                  setCookie("country_code", data.country_code, 30);
                  resolve(data.country_code.toLowerCase());
                }
              },
              error: function (error) {
                reject(error);
              },
            });
          },
        });
      }
    });
  }
}

const updateSection = async () => {
  let localization = new Localization();
  $("#shopify-section-location-popup .cc-popup").removeClass(
    "cc-popup--visible"
  );
  $(document).on("click", ".country-selector", function (e) {
    e.preventDefault();
    $("#shopify-section-location-popup .cc-popup").addClass(
      "cc-popup--visible"
    );
    if ($("#page-menu.reveal").length > 0) {
      $("a.menu").trigger("click");
    }
  });
  $("#shopify-section-location-popup .cc-popup-close").on("click", function () {
    $("#shopify-section-location-popup .cc-popup").removeClass(
      "cc-popup--visible"
    );
    setCookie("country_close", true, 30);
  });
  if (getCookie("country_close") && localization.mode !== "testing") return;
  $("#shopify-section-location-popup form").on("submit", function (e) {
    e.preventDefault();
    setCookie("country_close", true, 30);
    $(this).unbind("submit").submit();
  });

  try {
    let country_code = await localization.getCountryCode();
    if (
      localization.country !== country_code ||
      localization.mode === "testing"
    ) {
      setTimeout(() => {
        $(
          "#shopify-section-location-popup .cc-popup select[name='country_code']"
        )
          .val(country_code.toUpperCase())
          .trigger("change");
        $("#shopify-section-location-popup .cc-popup").addClass(
          "cc-popup--visible"
        );
      }, localization.delay * 1000);
    }
  } catch (error) {
    console.log(error);
  }
};

(async () => {
  await updateSection();
})();

$(window).on("shopify:section:load", function ({ target }) {
  $("#shopify-section-location-popup .cc-popup-close").off("click");
  $("#shopify-section-location-popup form").off("submit");
  $(".country-selector").off("click");
  $(
    "#shopify-section-location-popup select[name='country_code']"
  ).selectReplace();
  updateSection();
});
